import React from 'react';
import InputField from '../../../components/CustomFields/InputField';
import { academyLogger } from "utils/logger";

const PersonalInfo = ({ student, handleChange, handleChangeDynamicAttribute }) => {
    academyLogger.info(student.dob); // Log student.dob

    return (
        <section className="">
            <h2 className="text-lg font-semibold text-[#824296] text-center">Additional Details
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">





                {/* Dynamic Attributes */}
                {student.dynamicAttributes
                    ?.map((attribute, originalIndex) => ({ attribute, originalIndex }))
                    .filter(({ attribute }) => attribute.name === "How did you know about Velammal")
                    .map(({ attribute, originalIndex }) => (
                        <InputField
                            key={originalIndex}
                            id={`dynamicAttribute-${originalIndex}`}
                            label={attribute.name}
                            value={attribute.value}
                            onChange={(e) => handleChangeDynamicAttribute(originalIndex, e.target.value)}
                        />
                    ))}

            </div>
        </section>
    );
};

export default PersonalInfo;
